<script>
import PasswordSetupForm from '@/components/auth/PasswordSetupForm.vue';
import AuthService from '@/shared/services/auth.service';

export default {
  name: 'ResetPassword',
  components: { PasswordSetupForm },
  data() {
    return {
      code: null,
      processing: false,
      errorMessage: null,
      success: false,
    };
  },
  mounted() {
    this.code = this.$route.query.code || null;
  },
  methods: {
    async handleSubmit(password) {
      this.errorMessage = null;

      if (!this.code) {
        this.errorMessage = 'Code de réinitialisation invalide ou manquant.';
        return;
      }

      this.processing = true;

      try {
        await AuthService.resetPassword(this.code, password);
        this.success = true;
      } catch (err) {
        this.errorMessage =
          err.response?.data?.message ||
          'Erreur lors de la réinitialisation du mot de passe.';
      } finally {
        this.processing = false;
      }
    },
  },
};
</script>

<template>
  <PasswordSetupForm
    title="Réinitialiser le mot de passe"
    subtitle="Créez un nouveau mot de passe pour accéder à votre compte"
    submit-label="Réinitialiser le mot de passe"
    success-title="Mot de passe réinitialisé !"
    success-body="Votre mot de passe a été mis à jour. Vous pouvez maintenant vous connecter avec vos nouveaux identifiants."
    :code="code"
    :processing="processing"
    :api-error="errorMessage"
    :success="success"
    @submit="handleSubmit"
  />
</template>
